// if (!customElements.get('product-modal')) {
//   customElements.define(
//     'product-modal',
//     class ProductModal extends ModalDialog {
//       constructor() {
//         super();
//       }

//       hide() {
//         super.hide();
//       }

//       show(opener) {
//         super.show(opener);
//         this.showActiveMedia();
//       }

//       showActiveMedia() {
//         this.querySelectorAll(
//           `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
//         ).forEach((element) => {
//           element.classList.remove('active');
//         });
//         const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
//         const activeMediaTemplate = activeMedia.querySelector('template');
//         const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
//         activeMedia.classList.add('active');
//         activeMedia.scrollIntoView();

//         const container = this.querySelector('[role="document"]');
//         container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

//         if (
//           activeMedia.nodeName == 'DEFERRED-MEDIA' &&
//           activeMediaContent &&
//           activeMediaContent.querySelector('.js-youtube')
//         )
//           activeMedia.loadContent();
//       }
//     }
//   );
// }




if (!customElements.get('product-modal')) {
  class ProductModal extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('[id^="ModalClose-"]').forEach((button) => {
        button.addEventListener('click', this.hide.bind(this));
      });

      // 移除或注释掉点击背景关闭的监听器
      // this.addEventListener('click', (event) => {
      //   if (event.target === this) {
      //     this.hide();
      //   }
      // });
    }

    get open() {
      return this.hasAttribute('open');
    }

    set open(value) {
      if (value) {
        this.setAttribute('open', true);
        document.body.classList.add('overflow-hidden');
      } else {
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      }
    }

    hide() {
      this.open = false;
    }

    show() {
      this.open = true;
    }

    // 可选：添加ESC键关闭功能（如果需要）
    connectedCallback() {
      document.addEventListener('keydown', (event) => {
        if (event.code === 'Escape' && this.open) {
          this.hide();
        }
      });
    }
  }

  customElements.define('product-modal', ProductModal);
}
